import { render, staticRenderFns } from "./zselectmultiple.vue?vue&type=template&id=72991b9e&scoped=true&"
import script from "./zselectmultiple.vue?vue&type=script&lang=js&"
export * from "./zselectmultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72991b9e",
  null
  
)

export default component.exports